const inputs = document.querySelectorAll('input.text');

if (inputs ) {
    inputs.forEach(function(inputField) {
        inputField.addEventListener('input', function() {
            this.setAttribute('value', this.value);
        });
      
        inputField.addEventListener('click', function() {
            this.setAttribute('value', this.value);
        });
    });
}


